import SouldatesImage from "src/assets/img/souldates1.jpeg";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Link } from "react-router-dom";
import { themeStyle, getDomainMeta } from "src/themes";
import { useTranslation } from "react-i18next";

const schema = z.object({
  username: z
    .string()
    .min(4, { message: "Username/Email must have atleast 4 characters" }),
  password: z
    .string()
    .min(8, { message: "Password must have atleast 8 characters" }),
});
let domainMeta = getDomainMeta();
function Login({ loginUser }) {
  const signup = () => {
    document.getElementById("signupForm").style.left = "0%";
    document.getElementById("LoginForm").style.left = "-110%";
  };
  const phonesignup = () => {
    document.getElementById("phoneSignup").style.display = "flex";
    document.getElementById("phoneLogin").style.display = "none";
  };
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    setError,
    getValues,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: zodResolver(schema),
  });

  const onSubmit = async (data) => {
    let result = await loginUser(data.username, data.password);
    console.log("Login result:", result);
    if (!result.success) {
      setError("root", {
        message: result.message,
      });
    }
    return true;
  };

  if (window.gtag) {
    window.gtag("event", "login", {
      event_category: "User",
      event_label: "User logged in",
    });
  }

  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex absolute max-w-[400px] lg:left-[-110%] flex-col bg-black w-full h-full justify-center p-8 text-white rounded-[30px] transition-all duration-700 ease-in-out"
        id="LoginForm"
      >
        <h2 className="font-bold text-[36px] mx-auto">{t("Login")}</h2>
        <span className="ml-2 text-sm font-bold my-1 mt-4">
          {" "}
          {t("emailUsername")}
        </span>
        <input
          {...register("username")}
          className="p-2 px-4 bg-gray-100  text-black outline-none rounded-full"
          type="text"
          placeholder="Username"
        />
        {errors.username && (
          <p className="text-[#FFD700] text-xs italic mt-2">
            {errors.username.message}
          </p>
        )}
        <span className="ml-2 text-sm font-bold my-1 mt-4">
          {t("password")}
        </span>
        <input
          {...register("password")}
          className="p-2 px-4 bg-gray-100  text-black outline-none rounded-full"
          type="password"
          placeholder="******************"
        />

        {errors.password && (
          <p className="text-[#FFD700] text-xs italic mt-2">
            {errors.password.message}
          </p>
        )}
        <div className="flex items-center my-4 mx-2">
          <input type="checkbox" className="mr-2" />
          <span className="text-xs">Remember me</span>
        </div>
        <button
          type="submit"
          className="bg-white text-black w-max font-semibold py-2 px-8 rounded-full mx-auto mt-8"
        >
          {!isSubmitting ? t("Login") : "Please Wait"}
        </button>
        <span className="phone:hidden lg:flex text-sm mx-auto mt-6">
          {t("Do not have an account")} ? &nbsp;
          <strong className="cursor-pointer" onClick={signup}>
            {t("Signup")}
          </strong>
        </span>
        <span className="phone:flex lg:hidden text-sm mx-auto mt-6">
        {t("Do not have an account")} ? &nbsp;{" "}
          <strong className="cursor-pointer" onClick={phonesignup}>
          {t("Signup")}
          </strong>
        </span>

        {errors.root && (
          <center>
            <div className="text-[#FFD700] mt-4">{errors.root.message}</div>
          </center>
        )}
      </form>
    </>
  );
}

export default Login;
